import { CheckCircle2, AlertTriangle, Loader2, Clock } from "lucide-react";
import { TYPE_LABEL, STATUS_LABEL } from "../../lib/api";

const ICON = {
  done: <CheckCircle2 size={15} className="text-emerald-600" />,
  error: <AlertTriangle size={15} className="text-red-600" />,
  running: <Loader2 size={15} className="animate-spin text-orange-500" />,
  queued: <Clock size={15} className="text-zinc-400" />,
};

const JobRow = ({ job, selected, onSelect }) => (
  <button
    data-testid={`job-item-${job.id}`}
    onClick={() => onSelect(job.id)}
    className={`row-hover w-full border-b border-zinc-100 px-4 py-3 text-left ${selected ? "bg-orange-50" : ""}`}
  >
    <div className="flex items-center justify-between gap-3">
      <div className="flex min-w-0 items-center gap-2">
        {ICON[job.status]}
        <span className="truncate text-sm font-semibold">{job.filename}</span>
      </div>
      <span className="shrink-0 font-mono text-[10px] uppercase tracking-wider text-zinc-500">{TYPE_LABEL[job.type]}</span>
    </div>
    <div className="mt-2 h-1 w-full bg-zinc-100">
      <div data-testid={`job-progress-bar-${job.id}`} className={`bar-fill h-1 ${job.status === "error" ? "bg-red-500" : "bg-orange-500"}`} style={{ width: `${job.progress}%` }} />
    </div>
    <div className="mt-1.5 flex justify-between text-xs text-zinc-500">
      <span className="truncate" data-testid={`job-message-${job.id}`}>{job.message}</span>
      <span data-testid={`job-status-${job.id}`}>{STATUS_LABEL[job.status]} · {job.progress}%</span>
    </div>
  </button>
);

export const JobsPanel = ({ jobs, selectedId, onSelect }) => (
  <section className="panel flex flex-col" data-testid="jobs-list-container">
    <div className="border-b border-zinc-200 p-6 lg:px-8">
      <p className="eyebrow">Risk AI Engine</p>
      <h2 className="panel-title mt-1 text-xl sm:text-2xl">Documentos en proceso</h2>
      <p className="mt-2 text-sm text-zinc-500">
        {jobs.length} trabajos · {jobs.filter((j) => j.status === "done").length} completados ·{" "}
        {jobs.filter((j) => ["running", "queued"].includes(j.status)).length} activos
      </p>
    </div>
    <div className="max-h-[420px] flex-1 overflow-auto">
      {jobs.length === 0 && <p className="p-8 text-sm text-zinc-400" data-testid="jobs-empty">Sin trabajos. Sube archivos o carga las muestras.</p>}
      {jobs.map((j) => <JobRow key={j.id} job={j} selected={j.id === selectedId} onSelect={onSelect} />)}
    </div>
  </section>
);
